import React from 'react';

type StepperProps = {
  useModalContext: any;
  stepForms: Array<any>;
  onClose: (e: React.MouseEvent<HTMLInputElement>) => void;
};

export const Stepper = ({ useModalContext, stepForms, onClose }: StepperProps) => {
  const stepMap: { [key: number]: any } = { ...stepForms };
  const { step } = useModalContext();
  const Component = stepMap[step];

  return <Component onClose={onClose} />;
};
